import { ImportApi } from "@/api";
import { showSuccessSnackbar } from "@/utils/snackbar";

export async function importQuizzes(jsonObject) {
  const response = await ImportApi.importQuizzes(jsonObject);
  showSuccessSnackbar(response.status, response.data.message);
}
